import React from 'react';
import PropTypes from 'prop-types';

class SideMenuItem extends React.Component {
    render() {
        const { label, icon, action, active } = this.props;
        let itemId = typeof label === 'string' ? label : label.props.defaultMessage.toLowerCase();

        return (
            <div className={`col-xs-12 item no-select ${active ? 'active' : ''}`}>
                <div className="item-inner ellipsis" id={`side-menu-${itemId}`} onClick={action}>
                    {icon ? <i className="material-icons">{icon}</i> : null}
                    <span>{label}</span>
                </div>
            </div>
        );
    }
}

SideMenuItem.defaultProps = {
    label: undefined,
    icon: undefined,
    action: undefined,
    active: false
};

SideMenuItem.propTypes = {
    label: PropTypes.any.isRequired,
    icon: PropTypes.string,
    action: PropTypes.func.isRequired,
    active: PropTypes.bool
};

export default SideMenuItem;



// WEBPACK FOOTER //
// ./src/components/menus/side/item/index.jsx